<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <app-select class="m-1" [label]="'statuses'" [formControl]="form_statuses" [list]="availableStatuses"
      [isMultiple]="true" [isEnum]="true" enumName="SellingStatus"
      (valueChanged)="updateDataFromFilters()"></app-select>

    <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3">Afficher toutes
      colonnes</mat-slide-toggle>
  </div>
  <mat-divider></mat-divider>
  <div class="table-container">
    <div class="loading" *ngIf="isLoadingResults">
      <mat-spinner color="primary"></mat-spinner>
    </div>
    <table mat-table class="default" [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="propertyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Bien</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.propertyName}}</td>
      </ng-container>
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>Prix</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.price | currency:
          'EUR':'symbol':'1.0' }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Statut</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.status | translate }}</td>
      </ng-container>
      <ng-container matColumnDef="mandateType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type de mandat</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.mandateType| translate }}</td>
      </ng-container>
      <ng-container matColumnDef="dateOnSale">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date mise en vente</th>
        <td mat-cell *matCellDef="let row" class="no-mobile"> {{ row.dateOnSale | dateFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="dateAgreement">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date compromis</th>
        <td mat-cell *matCellDef="let row" class="no-mobile"> {{ row.dateAgreement | dateFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="dateSigning">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date signature</th>
        <td mat-cell *matCellDef="let row" class="no-mobile"> {{ row.dateSigning | dateFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="sellerRealtor">
        <th mat-header-cell *matHeaderCellDef>Agent vendeur</th>
        <td mat-cell *matCellDef="let row">{{ row.sellerRealtor }}</td>
      </ng-container>
      <ng-container matColumnDef="sellerNotary">
        <th mat-header-cell *matHeaderCellDef>Notaire vendeur</th>
        <td mat-cell *matCellDef="let row">{{ row.sellerNotary }}</td>
      </ng-container>
      <ng-container matColumnDef="buyerRealtor">
        <th mat-header-cell *matHeaderCellDef>Agent acheteur</th>
        <td mat-cell *matCellDef="let row">{{ row.buyerRealtor }}</td>
      </ng-container>
      <ng-container matColumnDef="buyerNotary">
        <th mat-header-cell *matHeaderCellDef>Notaire acheteur</th>
        <td mat-cell *matCellDef="let row">{{ row.buyerNotary }}</td>
      </ng-container>
      <ng-container matColumnDef="buyer">
        <th mat-header-cell *matHeaderCellDef>Acheteur</th>
        <td mat-cell *matCellDef="let row">{{ row.buyer }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row" class="mobile-double-actions">
          <button mat-icon-button [routerLink]="['/property', row.propertyUid]" appTooltip="Voir le bien">
            <mat-icon color="primary">remove_red_eye</mat-icon>
          </button>
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="row.demo ? 'is-demo' : ''">
      </tr>
    </table>

    <mat-paginator [length]="paging.length" [pageSize]="paging.pagingPageSize"
      [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>


<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <a (click)="confirmDelete(row.sale)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer la vente</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>